import { hexToRgbArray } from "./hex-to-rgb-array";

// Calculates brightness/luminance of the color using luminance formula
export const isColorBright = (colorHex: string): boolean => {
  const colorRGB: number[] = hexToRgbArray(colorHex);
  const brightness = Math.round(((colorRGB[0] * 299) + (colorRGB[1] * 587) + (colorRGB[2] * 114)) / 1000);
  return brightness > 125;
}
